var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlReadyPosp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_176391",
    "data-name": "Group 176391",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.843,
    height: 91.343,
    viewBox: "0 0 72.843 91.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_173436",
    "data-name": "Path 173436",
    d: "M216.115,318.558c-2.386-.208-10.688-4.359-15.668-6.537-.1,6.122,1.453,16.395,1.453,17.225-.1,1.141-2.8,4.255-7.886,11,0,0,0-2.491-.415-7.99-.311-4.15-2.283-6.33-2.283-8.509,0-.519,1.972-1.867,1.972-3.217s-.415-2.7-3.217-2.7-3.217,1.349-3.217,2.7,1.972,2.7,1.972,3.217c0,2.179-1.972,4.358-2.283,8.4-.415,5.5-.415,7.99-.415,7.99-5.085-6.744-7.782-9.857-7.886-11-.1-.83,1.453-11.1,1.453-17.225-5.4,2.283-13.7,6.434-16.085,6.642-2.8.208-3.528,1.038-4.877,3.424-1.453,2.386-4.774,14.216-5.292,21.791a88.053,88.053,0,0,0,72.843,0c-.519-7.575-3.839-19.4-5.292-21.791-1.349-2.386-2.075-3.112-4.877-3.424Z",
    transform: "translate(-153.442 -260.315)",
    fill: "#550acc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_173437",
    "data-name": "Path 173437",
    d: "M237.683,90.327h2.8L247.54,84.1V79.016c7.886-.622,15.253-2.179,16.81-3.528-7.056-6.433-4.566-17.64-6.122-27.913s-12.866-13.8-17.536-14.111-8.509,1.764-9.443,3.217c-5.4-2.283-10.48,7.471-10.584,12.763s-1.763,22.413-6.744,25.941a13.316,13.316,0,0,0,4.15,1.764,8.4,8.4,0,0,0,3.217-5.5,18.723,18.723,0,0,1-1.453,5.915l1.867.311a4.718,4.718,0,0,0,1.245-2.179c-.208.934-.311,1.66-.519,2.283,2.491.415,5.4.727,8.3.934V84Z",
    transform: "translate(-202.715 -33.433)",
    fill: "#550acc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlReadyPosp);
export default __webpack_public_path__ + "static/media/AlReadyPosp.0c46901e340bfa7056e692724aa06d02.svg";
export { ForwardRef as ReactComponent };